import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivitySetBy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.15039 12.6172L11.7397 16.5851L16.6504 9.11719",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.92236 8.77246C9.16521 8.77246 10.9834 6.95427 10.9834 4.71143C10.9834 2.46858 9.16521 0.650391 6.92236 0.650391C4.67951 0.650391 2.86133 2.46858 2.86133 4.71143C2.86133 6.95427 4.67951 8.77246 6.92236 8.77246Z",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.92346 15.5849H0.650391V14.6984C0.650391 11.4226 3.30146 8.77148 6.5773 8.77148H7.26118C9.22838 8.77148 10.9761 9.73397 12.0567 11.2115",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgActivitySetBy;
